import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { findBuildByLegacyName, findProjectBySlotName } from "../lib/builds";
import { getQuery } from "../lib/query";
import { projectPageUrl } from "../lib/projectUrl";

// ponytail: one release only, then delete this route with 005.
// Pre-004 links were /gallery?build=<build name or project slot name>&ver=…
// Resolve the name to its project once, then replace this history entry with
// the project page (or Discover when nothing matches).
export default function GalleryRedirect() {
  const navigate = useNavigate();
  const { region: regionParam } = useParams();
  const region = String(regionParam || "").toLowerCase() === "us" ? "us" : "in";

  useEffect(() => {
    let alive = true;
    const name = getQuery("build");

    (async () => {
      let id = null;
      try {
        id =
          (await findBuildByLegacyName(name))?.project_id ||
          (await findProjectBySlotName(name))?.id ||
          null;
      } catch (err) {
        console.error("[GalleryRedirect] lookup failed:", err);
      }
      if (!alive) return;
      navigate(
        id ? projectPageUrl(region, id, getQuery("tab") || undefined) : `/${region}/discover`,
        { replace: true }
      );
    })();

    return () => {
      alive = false;
    };
  }, [navigate, region]);

  return <div style={{ padding: 24 }}>Opening project…</div>;
}
